"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var util_localization_1 = require("@sport-thieme/util-localization");
var TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
exports.default = react_1.forwardRef(function TablePagination(_a, ref) {
    var _b = _a.rowsPerPageOptions, rowsPerPageOptions = _b === void 0 ? [10, 25, 50, 100] : _b, _c = _a.backIconButtonProps, backIconButtonProps = _c === void 0 ? { 'aria-label': util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["previous page"], ["previous page"]))) } : _c, _d = _a.nextIconButtonProps, nextIconButtonProps = _d === void 0 ? { 'aria-label': util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["next page"], ["next page"]))) } : _d, _e = _a.labelRowsPerPage, labelRowsPerPage = _e === void 0 ? util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Rows per page:"], ["Rows per page:"]))) : _e, _f = _a.labelDisplayedRows, labelDisplayedRows = _f === void 0 ? function (_a) {
        var from = _a.from, to = _a.to, count = _a.count;
        return util_localization_1.localize(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "-", " of ", ""], ["", "-", " of ", ""])), String(from), to === -1 ? String(count) : String(to), String(count));
    } : _f, rest = __rest(_a, ["rowsPerPageOptions", "backIconButtonProps", "nextIconButtonProps", "labelRowsPerPage", "labelDisplayedRows"]);
    return (jsx_runtime_1.jsx(TablePagination_1.default, __assign({ labelDisplayedRows: labelDisplayedRows, rowsPerPageOptions: rowsPerPageOptions, backIconButtonProps: backIconButtonProps, nextIconButtonProps: nextIconButtonProps, labelRowsPerPage: labelRowsPerPage }, rest, { ref: ref }), void 0));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=TablePagination.js.map